import { cloneObject, isset } from "../Utils";

export default class ProductVariations
{
    private data: object = {};
    private valueMatrix: object = {};
    private active: object = {};

    public getData(): object
    {
        return this.data;
    }

    public getActiveVariationData(groupId: number)
    {
        return this.data[groupId][this.active[groupId]];
    }

    public appendGroup(groupId: number, group: object)
    {
        this.appendDataGroup(groupId, group);
        this.loadOptionsSwitchingMatrix(groupId);
        this.extractActiveOption(groupId);
    }

    private appendDataGroup(groupId: number, group: object)
    {
        if (this.checkDataGroup(group)) {
            this.data[groupId] = group;
        } else {
            throw new TypeError("Unknown signature of variation group");
        }
    }

    private checkDataGroup(group: object): boolean
    {
        for (let idx in group) {
            let isValid = group.hasOwnProperty(idx) && isset(group[idx].id) && isset(group[idx].url)
                && isset(group[idx].options) && isset(group[idx].title);
    
            if (!isValid) {
                return false;
            }
        }

        return true;
    }

    private loadOptionsSwitchingMatrix(groupId: number)
    {
        let data = this.data[groupId];

        for (let variationKey in data) {
            if (!data.hasOwnProperty(variationKey)) {
                continue;
            }

            if (!isset(this.valueMatrix[groupId])) {
                this.valueMatrix[groupId] = {};
            }

            let variant = data[variationKey];

            for (let optionId in variant.options.keys) {
                if (!variant.options.keys.hasOwnProperty(optionId)) {
                    continue;
                }

                let optionKey = variant.options.keys[optionId];

                if (!isset(this.valueMatrix[groupId][optionKey])) {
                    this.valueMatrix[groupId][optionKey] = [];
                }

                for (let subOptionId in variant.options.keys) {
                    if (!variant.options.keys.hasOwnProperty(subOptionId) || optionId === subOptionId) {
                        continue;
                    }

                    let subOptionKey = variant.options.keys[subOptionId];

                    if (!this.valueMatrix[groupId][optionKey].includes(subOptionKey)) {
                        this.valueMatrix[groupId][optionKey].push(subOptionKey);
                    }
                }
            }
        }
    }

    private extractActiveOption(groupId: number)
    {
        let data = this.data[groupId];

        for (let variationKey in data) {
            if (!data.hasOwnProperty(variationKey)) {
                continue;
            }

            if (Number(data[variationKey].active) === 1 || !isset(this.active[groupId])) {
                this.active[groupId] = variationKey;
            }
        }
    }

    public switchActiveOption(groupId: number, optionId: number, newValue: number)
    {
        let variations = this.data[groupId];
        let currentVariation = this.getActiveVariationData(groupId);

        let newOptionSet = cloneObject(currentVariation.options.keys);
        newOptionSet[optionId] = Number(newValue);
        
        for (let variationKey in variations) {
            if (!variations.hasOwnProperty(variationKey)) {
                continue;
            }

            let optionSet = variations[variationKey].options.keys;
            let isEquals = true;

            for (let optionId in optionSet) {
                if (!optionSet.hasOwnProperty(optionId)) {
                    continue;
                }

                isEquals = isEquals && Number(optionSet[optionId]) === newOptionSet[optionId];
            }

            if (isEquals) {
                this.setActiveVariation(groupId, variationKey);
                return;
            }
        }
    }

    private setActiveVariation(groupId: number, variationKey: string)
    {
        this.active[groupId] = variationKey;
    }

    public getEnabledVariationValues(groupId: number): Number[]
    {
        let groupMatrix = this.valueMatrix[groupId];
        let currentValuesId = this.getActiveVariationData(groupId).options.keys;
        let enabledOptionValues = [];

        for (let optionId in currentValuesId) {
            enabledOptionValues = enabledOptionValues.concat(groupMatrix[currentValuesId[optionId]])
        }

        for (let i; i < enabledOptionValues.length; i++) {
            enabledOptionValues[i] = Number(enabledOptionValues[i]);
        }

        return enabledOptionValues;
    }
}
